<template>
  <div id="app">
    <div class="lang-switcher">
      <el-tooltip :content="localeLabel" placement="left">
        <button class="lang-btn" @click="toggleLocale" aria-label="Switch language">🌐</button>
      </el-tooltip>
    </div>
    <router-view />
  </div>
</template>

<script>
import { useI18n } from 'vue-i18n'
import { ref, watch, computed } from 'vue'

export default {
  name: 'App',
  setup() {
    const { locale } = useI18n()
    const currentLocale = ref(locale.value || 'en-US')

    const toggleLocale = () => {
      const next = currentLocale.value === 'zh-CN' ? 'en-US' : 'zh-CN'
      locale.value = next
      currentLocale.value = next
      localStorage.setItem('locale', next)
    }

    const localeLabel = computed(() => currentLocale.value === 'zh-CN' ? '中文' : 'English')

    watch(locale, (val) => {
      currentLocale.value = val
    })

    return { currentLocale, toggleLocale, localeLabel }
  }
}
</script>

<style>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  font-family: 'Microsoft YaHei', Arial, sans-serif;
}

#app {
  width: 100%;
  min-height: 100vh;
}

.lang-switcher {
  position: fixed;
  right: 24px;
  bottom: 24px;
  z-index: 9999;
}

.lang-btn {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: #fff;
  border: 1px solid #eaeaea;
  box-shadow: var(--shadow-md);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  cursor: pointer;
  transition: transform 0.2s, box-shadow 0.2s, color 0.2s, border-color 0.2s;
}

.lang-btn:hover {
  transform: translateY(-2px);
  box-shadow: var(--shadow-lg);
  color: var(--brand);
  border-color: var(--brand);
}
</style>